/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedFAQQuestion_question = {
    readonly id: string;
    readonly url: string | null;
    readonly title: string | null;
    readonly answerCount: number | null;
    readonly answers: ReadonlyArray<{
        readonly serviceId: string;
        readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQAnswer_answer">;
    } | null> | null;
    readonly " $refType": "BuySharedFAQQuestion_question";
};
export type BuySharedFAQQuestion_question$data = BuySharedFAQQuestion_question;
export type BuySharedFAQQuestion_question$key = {
    readonly " $data"?: BuySharedFAQQuestion_question$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQQuestion_question">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedFAQQuestion_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answerCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerType",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedFAQAnswer_answer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionType",
  "abstractKey": null
};
(node as any).hash = 'ea5012458d20fbcaa6fe5f87b6af05f8';
export default node;
